const API_SERVER_URL = "http://clk.selectmobi.com";
const SERVER_URL = window.origin;

// const API_SERVER_URL = "http://localhost:8080"
// const SERVER_URL = "http://localhost:8080";

export {
  SERVER_URL,
  API_SERVER_URL
}


// WEBPACK FOOTER //
// ./src/constant.js